import { useReducer } from 'react';
import { GlobalContext } from './GlobalContext';

const win = window as Window & { [key: string]: any };
const login_type = new URL(window.location.href).searchParams.get("login_type");
const returnUrl = window.location.search.length > 0 ? window.location.search.split("returnUrl=")[1] : '';
const token = new URL(window.location.href).searchParams.get("token");

const lang = win['lang'] || document.documentElement.lang;
const rtl = lang === 'ar';

const env = win.env;
let bmcs = import.meta.env.VITE_PD_BM_CS;

if (env === 'SIT') {
    bmcs = import.meta.env.VITE_SI_BM_CS;
} else if (env === 'PREPROD') {
    bmcs = import.meta.env.VITE_PP_BM_CS;
} else if (env === 'DEV') {
    bmcs = import.meta.env.VITE_DE_BM_CS;
} else if (env === 'SIT2') {
    bmcs = import.meta.env.VITE_SI2_BM_CS
}

let otpType = '';
let userType = '';
let bothType = '';

if (login_type) {
    if (login_type === 'otp') otpType = login_type;
    if (login_type === 'user') userType = login_type;
    if (login_type === 'both') bothType = login_type;
}

const initialState = {
    loading: false,
    rtl: rtl,
    otpType: otpType,
    userType: userType,
    bothType: bothType,
    msisdn: "",
    otpToken: "",
    returnUrl,
    loginActive: true,
    latitude: '',
    longitude: '',
    locationEnabled: false,
    token,
    mobileNumber: "",
    bmcs
}

const reducer = (state: any, action: any) => {
    switch (action.type) {
        case "LOADER":
            return {
                ...state,
                loading: action.payload.loading
            }
        case "MSISDN":
            return {
                ...state,
                msisdn: action.payload.msisdn,
                refId: action.payload.refId,
                mobileNumber: action.payload.mobileNumber,
                username: action.payload.username,
                password: action.payload.password,
            }
        case "USERNAME_PASSWORD":
            return {
                ...state,
                otpToken: action.payload.otpToken
            }

        case "LOGIN_ACTIVE":
            return {
                ...state,
                loginActive: action.payload.active
            }

        case "UPDATE_LOCATION":
            return {
                ...state,
                latitude: action.payload.latitude,
                longitude: action.payload.longitude,
                locationEnabled: action.payload.locationEnabled
            }
        default:
            return state;
    }
}


export function GlobalProvider({ children }: any) {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <GlobalContext.Provider value={{ state, dispatch }}>
            {children}
        </GlobalContext.Provider>
    );
}
